import { proxy } from 'valtio';

/**
 * Preview variant types for showing package availability on offering cards.
 * These can be A/B tested to find the best conversion rate.
 */
export type PackagePreviewVariant = 'badge' | 'inline' | 'price-range' | 'banner';

/**
 * Configuration for package preview display.
 * Change the variant to switch between different preview styles.
 */
export const packagePreviewConfig = proxy<{
  variant: PackagePreviewVariant;
}>({
  variant: 'badge',
});

/**
 * Set the package preview variant
 */
export function setPackagePreviewVariant(variant: PackagePreviewVariant) {
  packagePreviewConfig.variant = variant;
}

/**
 * Get the current package preview variant
 */
export function getPackagePreviewVariant(): PackagePreviewVariant {
  return packagePreviewConfig.variant;
}
